import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SocialWidgets } from "./components/SocialWidgets";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Products } from "./pages/Products";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <main className="pt-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
          </Routes>
        </main>
        <Footer />
        <SocialWidgets />
      </div>
    </BrowserRouter>
  );
}

export default App;
